import { css } from 'styled-components'

export default css`
  &.ChargebeeCheckoutModal {
    .BaseModal-Content.interactive,
    .BaseModal-Content.popup {
      width: min(1200px, 95vw);
      height: 95vh;
      background: rgb(246, 247, 251);
      border-radius: 10px;
    }

    .ChargebeeCheckoutModal-close {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 1;
    }

    /* Specificity-bumped: BaseModal styles target
       ".BaseModal-Content .BaseModal-Body" (specificity 0,3,0); ours
       needs to match or exceed that to override the white background. */
    .BaseModal-Content .BaseModal-Body {
      height: 100%;
      background: rgb(246, 247, 251);
      padding: 24px;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      box-shadow: none;
    }

    .ChargebeeCheckoutModal-iframe-host {
      flex: 1 1 auto;
      width: 100%;
      overflow: hidden;
    }

    .ChargebeeCheckoutModal-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      padding: 32px;
      gap: 16px;
      text-align: center;
    }
  }
`
